/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@import url(https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400&display=swap);@import url(https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400&display=swap);@import url(https://fonts.googleapis.com/css?family=Roboto+Mono:700&display=swap);.join-component,app-join~footer,app-join~header{max-width:600px}.join-component.card.standalone.error{background-color:#f6e6e5;border-color:#d9534f;color:#611715}.join-component.card.standalone.error .card-header{background-color:#d9534f;color:#fff}"];
export { styles as styles };
